export const footerItemsOne: Record<string, string>[] = [
  {
    title: "Our Blog",
    link: "/articles",
  },
  {
    title: "Study Guide",
    link: "/study-guide",
  },
  {
    title: "Gallery",
    link: "https://drive.google.com/drive/folders/11NJ3Za9O_gy9KperCv_YsFzfEmbaNNOb",
  },
  {
    title: "Events",
    link: "/events",
  },
];

export const footerItemsTwo: Record<string, string>[] = [
  {
    title: "Contact Us",
    link: "/contact-us",
  },
  {
    title: "Careers",
    link: "/career",
  },
  {
    title: "Conflict Resolution",
    link: "/conflict-resolution",
  },
  {
    title: "Donate",
    link: "/endowment",
  },
];

export const footerItemsThree: Record<string, string>[] = [
  {
    title: "Privacy Policy",
    link: "/privacy-policy",
  },
  {
    title: "Website Policy",
    link: "/website-policy",
  },
  {
    title: "Refund Policy",
    link: "/refund-policy",
  },
  {
    title: "Plagiarism Policy",
    link: "/plagiarism-policy",
  },
  {
    title: "Accessibility",
    link: "/accessibility",
  },
];
